import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BarTimeValue from '../Charts/BarTimeValue';
import { namedColor, transparentize } from 'Chart/ChartUtils';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import config from '../../../../config';
import DecimationTimeValue from '../Charts/DecimetionTimeValue';
import ChartTimeValue from '../Charts/ChartTimeValue';
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import Icon from "@mui/material/Icon";
// Otis Admin PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { DIAGRAM_COLORS } from 'diagrammColors';

const PublicTransportComp = ({ params }) => {
    const { t } = useTranslation();

    const [chartData, setChartData] = useState();
    const [expected, setExpected] = useState();
    const [noRouteData, setNoRouteData] = useState(false)

    useEffect(() => {

        async function fetchData() {
            try {
                const start_date = new Date(params.dates.from).toISOString().slice(0, -5) + "Z";
                const end_date = new Date(params.dates.to).toISOString().slice(0, -5) + "Z";
                console.log(params)
                let getUrl = config.ENDPOINTS_URL + `/rpc/th_eta_per_busstop?start_time=${start_date}&end_time=${end_date}&bus_stops={${params.selectedDetectors[0].id.toString()}}`;
                let header = "oasth";
                const response = await axios(getUrl, {
                    headers: {
                        "Accept-Profile": header
                    }
                });
                if (!response.data || response.data.length === 0) {
                    setNoRouteData(true)
                } else {
                    setNoRouteData(false);
                    let data = response.data.map((item) => ({
                        x: new Date(item.lasttimestamp_rounded).toLocaleString('en-GB'), // Format date to be readable
                        y: item.eta_actual_diff,
                    }));
                    const chartD = {
                        datasets: [
                            {
                                label: params.selectedDetectors[0].name,
                                data: data,
                                backgroundColor: DIAGRAM_COLORS[0],
                                borderWidth: 0, // Removes the connecting line                            
                                tension: 0.4, // Line smoothing
                                minBarLength: 7, // Ensures bars are visible even when value is 0
                            }
                        ]
                    };
                    setChartData(chartD);
                }
                getUrl = config.ENDPOINTS_URL + `/rpc/th_eta_busstop_average_eta?start_time=${start_date}&end_time=${end_date}&bus_stops={${params.selectedDetectors[0].id.toString()}}`;
                const response2 = await axios(getUrl, {
                    headers: {
                        "Accept-Profile": header
                    }
                });
                if (response2.data) {
                    setExpected(response2.data.value)
                } else {
                    setExpected(null)
                }
            } catch (error) {
                console.log(error)
            }
        }


        fetchData();
    }, [params])

    return (
        <Grid container={true} p={2}>
            {
                expected ? <MDBox mb={3}>
                    <MiniStatisticsCard
                        title={{ text: t("dataQuality.publicTransportComp.expectedArrival") }}
                        count={t("dataQuality.publicTransportComp.minutes", { value: expected })}
                        icon={{ color: "info", component: "train" }}
                        direction="left"
                    />
                </MDBox> : null
            }
            <div className='rawContainerDiagrams'>
                {chartData ? <div className='detectorDiagramsContainer'><BarTimeValue chartData={chartData} title="" /></div> : <div className='rawContainerCenteredH'>{noRouteData ? <span>{t("dataQuality.publicTransportComp.noDataForBusStop")}</span> : <CircularProgress />}</div>}
            </div>
        </Grid>
    );
};

export default PublicTransportComp;